var map = {
  "./icon-academic-cap.png": "8036",
  "./icon-adjustments-horizontal.png": "68769",
  "./icon-adjustments-vertical.png": "93491",
  "./icon-archive-box-arrow-down.png": "79443",
  "./icon-archive-box-x-mark.png": "83651",
  "./icon-archive-box.png": "1351",
  "./icon-arrow-down-circle.png": "95753",
  "./icon-arrow-down-left.png": "32712",
  "./icon-arrow-down-on-square-stack.png": "11917",
  "./icon-arrow-down-on-square.png": "81242",
  "./icon-arrow-down-right.png": "22973",
  "./icon-arrow-down-tray.png": "93245",
  "./icon-arrow-down.png": "71606",
  "./icon-arrow-left-circle.png": "46599",
  "./icon-arrow-left-on-rectangle.png": "53101",
  "./icon-arrow-left.png": "41431",
  "./icon-arrow-long-down.png": "95451",
  "./icon-arrow-long-left.png": "73436",
  "./icon-arrow-long-right.png": "34817",
  "./icon-arrow-long-up.png": "52367",
  "./icon-arrow-path-rounded-square.png": "30578",
  "./icon-arrow-path.png": "38550",
  "./icon-arrow-right-circle.png": "34902",
  "./icon-arrow-right-on-rectangle.png": "23479",
  "./icon-arrow-right.png": "3554",
  "./icon-arrow-small-down.png": "15228",
  "./icon-arrow-small-left.png": "60388",
  "./icon-arrow-small-right.png": "7101",
  "./icon-arrow-small-up.png": "70002",
  "./icon-arrow-top-right-on-square.png": "99702",
  "./icon-arrow-trending-down.png": "9441",
  "./icon-arrow-trending-up.png": "81939",
  "./icon-arrow-up-circle.png": "93842",
  "./icon-arrow-up-left.png": "90229",
  "./icon-arrow-up-on-square-stack.png": "4734",
  "./icon-arrow-up-on-square.png": "45774",
  "./icon-arrow-up-right.png": "25965",
  "./icon-arrow-up-tray.png": "10536",
  "./icon-arrow-up.png": "23768",
  "./icon-arrow-uturn-down.png": "85626",
  "./icon-arrow-uturn-left.png": "32352",
  "./icon-arrow-uturn-right.png": "49523",
  "./icon-arrow-uturn-up.png": "44444",
  "./icon-arrows-pointing-in.png": "70806",
  "./icon-arrows-pointing-out.png": "83484",
  "./icon-arrows-right-left.png": "49334",
  "./icon-arrows-up-down.png": "67832",
  "./icon-at-symbol.png": "80427",
  "./icon-backspace.png": "21046",
  "./icon-backward.png": "55303",
  "./icon-banknotes.png": "96551",
  "./icon-bars-2.png": "9169",
  "./icon-bars-3-bottom-left.png": "30805",
  "./icon-bars-3-bottom-right.png": "20514",
  "./icon-bars-3-center-left.png": "10719",
  "./icon-bars-3.png": "18187",
  "./icon-bars-4.png": "5289",
  "./icon-bars-arrow-down.png": "77634",
  "./icon-bars-arrow-up.png": "83331",
  "./icon-battery-0.png": "31787",
  "./icon-battery-100.png": "46378",
  "./icon-battery-50.png": "55237",
  "./icon-beaker.png": "81719",
  "./icon-bell-alert.png": "2829",
  "./icon-bell-slash.png": "79271",
  "./icon-bell-snooze.png": "25026",
  "./icon-bell.png": "96626",
  "./icon-bolt-slash.png": "39152",
  "./icon-bolt.png": "56746",
  "./icon-book-open.png": "85993",
  "./icon-bookmark-slash.png": "38590",
  "./icon-bookmark-square.png": "12126",
  "./icon-bookmark.png": "42176",
  "./icon-briefcase.png": "53613",
  "./icon-bug-ant.png": "58022",
  "./icon-building-library.png": "84436",
  "./icon-building-office-2.png": "90218",
  "./icon-building-office.png": "19081",
  "./icon-building-storefront.png": "48793",
  "./icon-cake.png": "65554",
  "./icon-calculator.png": "23018",
  "./icon-calendar-days.png": "87232",
  "./icon-calendar.png": "64562",
  "./icon-camera.png": "39324",
  "./icon-chart-bar-square.png": "98547",
  "./icon-chart-bar.png": "25435",
  "./icon-chart-pie.png": "34274",
  "./icon-chat-bubble-bottom-center-text.png": "6848",
  "./icon-chat-bubble-bottom-center.png": "98583",
  "./icon-chat-bubble-left-ellipsis.png": "10774",
  "./icon-chat-bubble-left-right.png": "41807",
  "./icon-chat-bubble-left.png": "49766",
  "./icon-chat-bubble-oval-left-ellipsis.png": "38471",
  "./icon-chat-bubble-oval-left.png": "33009",
  "./icon-check-badge.png": "6784",
  "./icon-check-circle.png": "81043",
  "./icon-check.png": "98194",
  "./icon-chevron-double-down.png": "93893",
  "./icon-chevron-double-left.png": "79653",
  "./icon-chevron-double-right.png": "96682",
  "./icon-chevron-double-up.png": "72907",
  "./icon-chevron-down.png": "74960",
  "./icon-chevron-left.png": "34017",
  "./icon-chevron-right.png": "87179",
  "./icon-chevron-up-down.png": "89643",
  "./icon-chevron-up.png": "54114",
  "./icon-circle-stack.png": "59166",
  "./icon-clipboard-document-check.png": "53963",
  "./icon-clipboard-document-list.png": "46114",
  "./icon-clipboard-document.png": "33708",
  "./icon-clipboard.png": "80382",
  "./icon-clock.png": "14667",
  "./icon-cloud-arrow-down.png": "59050",
  "./icon-cloud-arrow-up.png": "5416",
  "./icon-cloud.png": "73498",
  "./icon-code-bracket-square.png": "64509",
  "./icon-code-bracket.png": "74578",
  "./icon-cog-6-tooth.png": "1582",
  "./icon-cog-8-tooth.png": "67193",
  "./icon-cog.png": "18844",
  "./icon-command-line.png": "43941",
  "./icon-computer-desktop.png": "99401",
  "./icon-cpu-chip.png": "5778",
  "./icon-credit-card.png": "31365",
  "./icon-cube-transparent.png": "97602",
  "./icon-cube.png": "47367",
  "./icon-currency-bangladeshi.png": "2486",
  "./icon-currency-dollar.png": "19794",
  "./icon-currency-euro.png": "33969",
  "./icon-currency-pound.png": "63894",
  "./icon-currency-rupee.png": "57378",
  "./icon-currency-yen.png": "21964",
  "./icon-cursor-arrow-rays.png": "25678",
  "./icon-cursor-arrow-ripple.png": "26258",
  "./icon-device-phone-mobile.png": "12888",
  "./icon-device-tablet.png": "81311",
  "./icon-document-arrow-down.png": "95535",
  "./icon-document-arrow-up.png": "2851",
  "./icon-document-chart-bar.png": "6605",
  "./icon-document-check.png": "58719",
  "./icon-document-duplicate.png": "73504",
  "./icon-document-magnifying-glass.png": "66911",
  "./icon-document-minus.png": "38960",
  "./icon-document-plus.png": "25470",
  "./icon-document-text.png": "88267",
  "./icon-document.png": "12125",
  "./icon-ellipsis-horizontal-circle.png": "26751",
  "./icon-ellipsis-horizontal.png": "28216",
  "./icon-ellipsis-vertical.png": "94048",
  "./icon-envelope-open.png": "32256",
  "./icon-envelope.png": "21017",
  "./icon-exclamation-circle.png": "55998",
  "./icon-exclamation-triangle.png": "22238",
  "./icon-eye-dropper.png": "63058",
  "./icon-eye-slash.png": "65670",
  "./icon-eye.png": "44699",
  "./icon-face-frown.png": "67617",
  "./icon-face-smile.png": "12258",
  "./icon-film.png": "85205",
  "./icon-finger-print.png": "96566",
  "./icon-fire.png": "9642",
  "./icon-flag.png": "37240",
  "./icon-folder-arrow-down.png": "44097",
  "./icon-folder-minus.png": "56128",
  "./icon-folder-open.png": "2272",
  "./icon-folder-plus.png": "93483",
  "./icon-folder.png": "4505",
  "./icon-forward.png": "34347",
  "./icon-funnel.png": "68463",
  "./icon-gif.png": "24707",
  "./icon-gift-top.png": "27750",
  "./icon-gift.png": "18823",
  "./icon-globe-alt.png": "27819",
  "./icon-globe-americas.png": "1614",
  "./icon-globe-asia-australia.png": "40200",
  "./icon-globe-europe-africa.png": "61417",
  "./icon-hand-raised.png": "58128",
  "./icon-hand-thumb-down.png": "22991",
  "./icon-hand-thumb-up.png": "47904",
  "./icon-hashtag.png": "28770",
  "./icon-heart.png": "68276",
  "./icon-home-modern.png": "69407",
  "./icon-home.png": "98629",
  "./icon-identification.png": "3030",
  "./icon-inbox-arrow-down.png": "79575",
  "./icon-inbox-stack.png": "90673",
  "./icon-inbox.png": "79844",
  "./icon-information-circle.png": "14714",
  "./icon-key.png": "18174",
  "./icon-language.png": "73820",
  "./icon-lifebuoy.png": "60454",
  "./icon-light-bulb.png": "42755",
  "./icon-link.png": "84900",
  "./icon-list-bullet.png": "47296",
  "./icon-lock-closed.png": "56131",
  "./icon-lock-open.png": "10674",
  "./icon-magnifying-glass-circle.png": "38394",
  "./icon-magnifying-glass-minus.png": "13598",
  "./icon-magnifying-glass-plus.png": "76223",
  "./icon-magnifying-glass.png": "54376",
  "./icon-map-pin.png": "61654",
  "./icon-map.png": "99248",
  "./icon-megaphone.png": "25822",
  "./icon-microphone.png": "77317",
  "./icon-minus-circle.png": "30291",
  "./icon-minus-small.png": "10423",
  "./icon-minus.png": "10494",
  "./icon-moon.png": "73512",
  "./icon-musical-note.png": "37897",
  "./icon-newspaper.png": "32591",
  "./icon-no-symbol.png": "86889",
  "./icon-paint-brush.png": "6467",
  "./icon-paper-airplane.png": "24021",
  "./icon-paper-clip.png": "33021",
  "./icon-pause-circle.png": "96473",
  "./icon-pause.png": "55944",
  "./icon-pencil-square.png": "68005",
  "./icon-pencil.png": "39431",
  "./icon-phone-arrow-down-left.png": "2873",
  "./icon-phone-arrow-up-right.png": "18061",
  "./icon-phone-x-mark.png": "61337",
  "./icon-phone.png": "90925",
  "./icon-photo.png": "44943",
  "./icon-play-circle.png": "538",
  "./icon-play-pause.png": "98099",
  "./icon-play.png": "45462",
  "./icon-plus-circle.png": "78044",
  "./icon-plus-small.png": "74875",
  "./icon-plus.png": "61003",
  "./icon-power.png": "15315",
  "./icon-presentation-chart-bar.png": "46847",
  "./icon-presentation-chart-line.png": "96964",
  "./icon-printer.png": "83159",
  "./icon-puzzle-piece.png": "20944",
  "./icon-qr-code.png": "93144",
  "./icon-question-mark-circle.png": "16523",
  "./icon-queue-list.png": "81258",
  "./icon-radio.png": "16300",
  "./icon-receipt-percent.png": "58643",
  "./icon-receipt-refund.png": "67016",
  "./icon-rectangle-group.png": "11853",
  "./icon-rectangle-stack.png": "79749",
  "./icon-rocket-launch.png": "68218",
  "./icon-rss.png": "37072",
  "./icon-scale.png": "26257",
  "./icon-scissors.png": "24055",
  "./icon-server-stack.png": "52179",
  "./icon-server.png": "54668",
  "./icon-share.png": "35367",
  "./icon-shield-check.png": "97486",
  "./icon-shield-exclamation.png": "46796",
  "./icon-shopping-bag.png": "40176",
  "./icon-shopping-cart.png": "80946",
  "./icon-signal-slash.png": "26780",
  "./icon-signal.png": "1359",
  "./icon-sparkles.png": "55989",
  "./icon-speaker-wave.png": "74821",
  "./icon-speaker-x-mark.png": "30591",
  "./icon-square-2-stack.png": "48992",
  "./icon-square-3-stack-3d.png": "66390",
  "./icon-squares-2x2.png": "73932",
  "./icon-squares-plus.png": "40552",
  "./icon-star.png": "48641",
  "./icon-stop-circle.png": "48129",
  "./icon-stop.png": "52885",
  "./icon-sun.png": "65662",
  "./icon-swatch.png": "92685",
  "./icon-table-cells.png": "1751",
  "./icon-tag.png": "29477",
  "./icon-ticket.png": "5714",
  "./icon-trash.png": "13052",
  "./icon-trophy.png": "51509",
  "./icon-truck.png": "28140",
  "./icon-tv.png": "2063",
  "./icon-user-circle.png": "33236",
  "./icon-user-group.png": "42062",
  "./icon-user-minus.png": "80218",
  "./icon-user-plus.png": "56027",
  "./icon-user.png": "38516",
  "./icon-users.png": "49187",
  "./icon-variable.png": "68860",
  "./icon-video-camera-slash.png": "5620",
  "./icon-video-camera.png": "22982",
  "./icon-view-columns.png": "36073",
  "./icon-viewfinder-circle.png": "25296",
  "./icon-wallet.png": "34084",
  "./icon-wifi.png": "74637",
  "./icon-window.png": "70406",
  "./icon-wrench-screwdriver.png": "81933",
  "./icon-wrench.png": "97086",
  "./icon-x-circle.png": "44648",
  "./icon-x-mark.png": "22425"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59187;
